module.exports = __webpack_public_path__ + "static/inpower_card-bee9e9f2b21876ac34755facd277b265.png";